import { CompanyNumber } from "@components/virtual-receptionist/widget";
import { gatewayPhone } from "src/gateways/gatewayPhone";

export const getCompanyNumbers = async (): Promise<CompanyNumber[]> => {
    try {
        const res = await gatewayPhone.get("/company-numbers");
        return res.data
    } catch (error) {
        console.error(error);
        return [];
    }
};